import { ValueFormatterParams } from "ag-grid-community";
import moment from "moment";
import dayjs from "dayjs";
import { dateFormat, dateTimeFormatForBE } from "components/Utils/dayjsUtils";

export const decimalNumberFormatter = (params: ValueFormatterParams) => {
  return params.value.toLocaleString("en", {
    maximumFractionDigits: 4,
    minimumFractionDigits: 0,
    useGrouping: false,
  });
};

export const dateFormatter = (params: ValueFormatterParams) =>
  params.value ? dayjs(params.value).format(dateFormat) : "-";

export const currencyBGNFormatter = (params: ValueFormatterParams) =>
  `${params?.value} €`;

export const formatCurrency = (
  value: number | string | null | undefined,
  minDigits: number = 2,
  maxDigits: number = 2
): string => {
  if (value === null || value === undefined) return "";

  const num = Number(value);
  if (isNaN(num)) return String(value);

  return num.toLocaleString("en-US", {
    minimumFractionDigits: minDigits,
    maximumFractionDigits: maxDigits,
    useGrouping: true,
  });
};

export const currencyFormatter = (
  params: ValueFormatterParams,
  minDigits?: number,
  maxDigits?: number
) => {
  return formatCurrency(params?.value, minDigits, maxDigits);
};

export const dateTimeFormatter = (params: ValueFormatterParams, format = dateTimeFormatForBE) => {
  if (!params?.value) return "-";

  return moment(new Date(params.value)).format(format);
}